import { defineStore } from 'pinia'
import { ref } from 'vue'
import curry from 'ramda/es/curry'

const isMatch = curry(
    (profID, x) => x.profession_id === profID || x.professionID === profID
)
const existsFor = curry((profID, state) =>
    state.allAnswersStats.some(isMatch(profID))
)
const findAllFor = curry((profID, state) => ({
    allQuestionsCounts: state.allQuestionsCounts.filter(isMatch(profID)),
    allAnswersStats: state.allAnswersStats.filter(isMatch(profID)),
}))

export const useAnswersStatsStore = defineStore('answersStats', () => {
    const allQuestionsCounts = ref([])
    const allAnswersStats = ref([])

    const snapshot = () => ({
        allQuestionsCounts: allQuestionsCounts.value,
        allAnswersStats: allAnswersStats.value,
    })

    const existsAnswerStatsFor = (professionID) => existsFor(professionID, snapshot())
    const getAnswerStatsFor = (professionID) => findAllFor(professionID, snapshot())

    const resetAnswersStats = () => {
        allAnswersStats.value = []
        allQuestionsCounts.value = []
    }

    const addToAnswersStats = (stat) => {
        allAnswersStats.value =
            allAnswersStats.value.filter(
                (x) => x.profession_id !== stat.professionID
            ) || []
        stat.allStats.forEach((x) => allAnswersStats.value.push(x))
        allQuestionsCounts.value =
            allQuestionsCounts.value.filter(
                (x) => x.professionID !== stat.professionID
            ) || []
        stat.allQuestionsCountsByMainCategory.forEach((x) =>
            allQuestionsCounts.value.push(x)
        )
    }

    return {
        allQuestionsCounts,
        allAnswersStats,
        existsAnswerStatsFor,
        getAnswerStatsFor,
        resetAnswersStats,
        addToAnswersStats,
    }
})
